// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-data[data-v-cb7e6ad8]{padding-bottom:30px;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
